/**
 * Application Translations Module
 */
import { applicationPt } from './pt'
import { applicationEn } from './en'

export const application = {
  pt: applicationPt,
  en: applicationEn,
}
